import { useEffect, useRef } from 'react';

/** The `useEnsuredForwardedRef` method was adapted from the react-use project (from
 *  useEnsuredForwardedRef). react-use is licensed under the "Unlicense License".
 * Source: https://github.com/streamich/react-use/blob/1bfe0636643a519bcbc3e620d9e384b4870a5a8b/src/useEnsuredForwardedRef.ts
 * */

/**
 * Used to ensure that a provided ref is always available, even if one was not
 * originally provided.
 * @param forwardedRef - The ref to ensure is always set.
 * @returns Returns a guaranteed ref object that can be
 * used and is synchronized to the provided ref.
 */
export function useEnsuredForwardedRef<T = unknown>(forwardedRef: React.MutableRefObject<T>) {
  const ensuredRef = useRef(forwardedRef?.current);

  useEffect(() => {
    if (!forwardedRef) {
      return;
    }

    forwardedRef.current = ensuredRef.current;
  }, [forwardedRef]);

  return ensuredRef;
}
